module.exports = __webpack_public_path__ + "img/classic_8.aedfd2da.png";